module.exports = __webpack_public_path__ + "img/monitor-05.3b6b2730.svg";